import { useState } from "react";
import InvoicesHeader from "./components/InvoicesHeader";
import InvoicesTable from "./components/InvoicesTable";

const Invoices = () => {
  const [data, setData] = useState([]);

  const [tableOptions, setTableOptions] = useState({
    status: false,
    posted: true,
    year: "",
    month: "",
    date: "",
    search_query: "",
    current_page: 1,
    size: 10,
    sort_column: { path: "is_paid", order: "desc" },
  });

  const columns = [
    { path: "year", label: "Year" },
    { path: "account_number", label: "Account No." },
    { path: "name", label: "Name" },
    { path: "invoice_number", label: "Invoice No." },
    { path: "period", label: "Period" },
    { path: "amount", label: "Amount" },
    { path: "is_paid", label: "Status" },
  ];

  return (
    <div className="px-6 lg:px-0">
      <div className="card">
        <InvoicesHeader options={tableOptions} onChange={setTableOptions} />
        <InvoicesTable
          data={data}
          columns={columns}
          options={tableOptions}
          onChange={setTableOptions}
          setData={setData}
        />
      </div>
    </div>
  );
};

export default Invoices;
